import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { IconType } from 'antd/lib/notification';
import { postAuth, postSso, postSsoCallback, postValidateToken } from './Services/AuthService';
import axios from 'axios';

// Async actions
export const notify = createAsyncThunk(
  'app/notify',
  async (
    { message, notificationType }: { message: string; notificationType: IconType },
    thunkAPI
  ) => {
    return { message, notificationType };
  }
);

export const login = createAsyncThunk(
  'app/login',
  async ({ username, sso }: { username: string; sso: boolean }, thunkAPI) => {
    return await postAuth(username, sso);
  }
);

export const ssoLogin = createAsyncThunk(
  'app/ssoLogin',
  async ({ sso }: { sso: boolean }, thunkAPI) => {
    return await postSso(sso);
  }
);

export const logout = createAction('app/logout');

export const initialise = createAsyncThunk('app/initialise', async (thunkAPI) => {
  const data = localStorage.getItem('user-details');
  if (data) {
    return await postValidateToken(JSON.parse(data));
  }
  throw new Error('Not Logged On');
});

export const callback = createAsyncThunk('app/callback', async (code: string, thunkAPI) => {
  return await postSsoCallback(code);
});

// Loading actions
export const showLoading = createAction('app/showLoading');
export const hideLoading = createAction('app/hideLoading');

// Slice definition
export const applicationData = createSlice({
  name: 'applicationData',
  initialState: {
    messages: [] as { message: string; notificationType: IconType }[],
    loading: false,
    authenticated: false,
    user_details: { name: '', role: '', email: '' },
    authenticating: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(notify.fulfilled, (state, action) => {
        state.messages = [action.payload];
      })
      .addCase(showLoading, (state) => {
        state.loading = true;
      })
      .addCase(hideLoading, (state) => {
        state.loading = false;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.authenticated = true;

        // const flattenedDetails = {
        //   ...action.payload.user,
        //   token: action.payload.token
        // };

        // state.user_details = flattenedDetails;

        // localStorage.setItem('user-details', JSON.stringify(flattenedDetails));

        // if (action.payload.token) {
        //   axios.defaults.headers.common['Authorization'] = action.payload.token;
        // }
      })
      .addCase(login.pending, (state) => {
        state.authenticating = true;
      })
      .addCase(login.rejected, (state) => {
        state.authenticated = false;
        state.authenticating = false;
        state.user_details = { name: '', role: '', email: '' };
      })
      .addCase(callback.fulfilled, (state, action) => {
        state.authenticated = true;

        // const flattenedDetails = {
        //   ...action.payload.user,
        //   token: action.payload.token
        // };

        // state.user_details = flattenedDetails;

        // localStorage.setItem('user-details', JSON.stringify(flattenedDetails));

        // if (action.payload.token) {
        //   axios.defaults.headers.common['Authorization'] = action.payload.token;
        // }
      })
      .addCase(callback.pending, (state) => {
        state.authenticating = true;
      })
      .addCase(callback.rejected, (state) => {
        state.authenticated = false;
        state.authenticating = false;
        state.user_details = { name: '', role: '', email: '' };
      })
      .addCase(logout, (state) => {
        localStorage.clear();
        state.authenticated = false;
        state.user_details = { name: '', role: '', email: '' };
      })
      .addCase(initialise.pending, (state) => {
        state.authenticating = true;
      })
      .addCase(initialise.fulfilled, (state, action) => {
        if (action.payload) {
          // const flattenedDetails = {
          //   ...action.payload.user,
          //   token: action.payload.token
          // };

          // state.user_details = flattenedDetails;
          // state.authenticated = true;
          // state.authenticating = false;

          // localStorage.setItem('user-details', JSON.stringify(flattenedDetails));

          // if (action.payload.token) {
          //   axios.defaults.headers.common['Authorization'] = action.payload.token;
          // }
        }
        state.authenticating = false;
      })
      .addCase(initialise.rejected, (state) => {
        state.authenticated = false;
        state.authenticating = false;
        state.user_details = { name: '', role: '', email: '' };
        localStorage.removeItem('user-details');
        axios.defaults.headers.common['Authorization'] = '';
      });
  }
});

export default applicationData.reducer;
